<template>
  <div v-if="visible" class="advertisement-popup" :class="positionClass" :style="popupStyle">
    <div class="advertisement-content">
      <div class="advertisement-header">
        <h3>{{ advertisement.title }}</h3>
        <button class="close-btn" @click="closePopup">
          <i class="el-icon-close"></i>
        </button>
      </div>
      <div class="advertisement-body">
        <div v-if="advertisement.imageUrl" class="advertisement-image">
          <img :src="advertisement.imageUrl" alt="广告图片" @click="handleImageClick" />
        </div>
        <div class="advertisement-text" v-html="advertisement.content"></div>
        <div v-if="advertisement.linkUrl" class="advertisement-link">
          <el-button type="primary" size="small" @click="handleLinkClick">查看详情</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActiveAdvertisement, logAdvertisementAction } from '@/api/advertisement'

export default {
  name: 'AdvertisementPopup',
  data() {
    return {
      visible: false,
      advertisement: {},
      positionClass: 'bottom-left',
      popupStyle: {
        width: '400px',
        height: '300px'
      }
    }
  },
  mounted() {
    this.loadAdvertisement()
  },
  methods: {
    async loadAdvertisement() {
      try {
        const response = await getActiveAdvertisement()
        const payload = response && response.data ? (response.data.data || response.data) : null
        console.log('[AdPopup] active response:', response)
        console.log('[AdPopup] active payload:', payload)
        if (payload) {
          this.advertisement = payload
          const pos = (this.advertisement.position || 'bottom-right')
          this.positionClass = pos
          this.popupStyle = {
            width: (this.advertisement.width || 400) + 'px',
            height: (this.advertisement.height || 300) + 'px'
          }

          const hasContent = !!(this.advertisement.title || this.advertisement.content || this.advertisement.imageUrl)
          if (!hasContent) {
            console.warn('[AdPopup] No content in active advertisement, skip showing')
            return
          }

          setTimeout(() => {
            this.showPopup()
          }, this.advertisement.showDelay || 3000)
        }
      } catch (error) {
        console.error('加载广告失败:', error)
      }
    },
    
    showPopup() {
      this.visible = true
      this.logAction('show')
    },
    
    closePopup() {
      this.visible = false
      this.logAction('close')
    },
    
    handleImageClick() {
      if (this.advertisement.linkUrl) {
        this.handleLinkClick()
      }
    },
    
    handleLinkClick() {
      if (this.advertisement.linkUrl) {
        this.logAction('click')
        window.open(this.advertisement.linkUrl, '_blank')
      }
    },
    
    async logAction(action) {
      try {
        await logAdvertisementAction({
          advertisementId: this.advertisement.id,
          userId: this.$store.getters.userId,
          action: action,
          ipAddress: this.getClientIP(),
          userAgent: navigator.userAgent
        })
      } catch (error) {
        console.error('记录广告操作日志失败:', error)
      }
    },
    
    getClientIP() {
      // 这里可以通过后端API获取真实IP，前端只能获取到代理IP
      return '127.0.0.1'
    }
  }
}
</script>

<style scoped>
.advertisement-popup {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid #e4e7ed;
  animation: slideIn 0.3s ease-out;
}

.advertisement-popup.bottom-left {
  bottom: 20px;
  left: 20px;
}

.advertisement-popup.bottom-right {
  bottom: 20px;
  right: 20px;
}

/* 强制显示在左下角 */

.advertisement-popup.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.advertisement-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.advertisement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px 8px 0 0;
}

.advertisement-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.advertisement-body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.advertisement-image {
  text-align: center;
  margin-bottom: 15px;
}

.advertisement-image img {
  max-width: 100%;
  max-height: 150px;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s;
}

.advertisement-image img:hover {
  transform: scale(1.05);
}

.advertisement-text {
  line-height: 1.6;
  color: #606266;
  margin-bottom: 20px;
  font-size: 14px;
}

.advertisement-link {
  text-align: center;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .advertisement-popup {
    width: 90% !important;
    max-width: 400px;
    left: 5% !important;
    right: 5% !important;
  }
  
  .advertisement-popup.bottom-left,
  .advertisement-popup.bottom-right {
    bottom: 10px;
    left: 5% !important;
    right: 5% !important;
  }
}
</style> 